(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.querySelector('[data-astra-hero]');
  if (!root) return;
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-astra-slide]'));
  if (!slides.length) return;

  function markEntered() {
    window.requestAnimationFrame(function () {
      root.classList.add('is-entered');
      if (slides[0]) slides[0].classList.add('is-settling');
    });
  }

  if (slides.length < 2) {
    markEntered();
    return;
  }

  var index = 0;
  var timer = 0;
  var stopped = false;
  var startX = 0;
  var startY = 0;
  var tracking = false;
  var autoplay = root.getAttribute('data-autoplay') === 'true' && !reduce;
  var delay = Math.max(6000, Number(root.getAttribute('data-autoplay-ms')) || 8000);
  var live = root.querySelector('[data-astra-hero-live]');
  var ticks = Array.prototype.slice.call(root.querySelectorAll('[data-astra-hero-tick]'));

  function setSlide(i, announce) {
    slides.forEach(function (slide, n) {
      var on = n === i;
      slide.classList.toggle('is-active', on);
      slide.classList.toggle('is-settling', on);
      slide.setAttribute('aria-hidden', on ? 'false' : 'true');
      if ('inert' in slide) slide.inert = !on;
      slide.removeAttribute('hidden');
      slide.querySelectorAll('a, button').forEach(function (el) {
        if (on) el.removeAttribute('tabindex');
        else el.setAttribute('tabindex', '-1');
      });
    });
    ticks.forEach(function (tick) {
      var n = Number(tick.getAttribute('data-index'));
      if (n === i) tick.setAttribute('aria-current', 'true');
      else tick.removeAttribute('aria-current');
    });
    if (announce && live) live.textContent = slides[i].getAttribute('data-label') || '';
    index = i;
  }

  function go(next, user) {
    var total = slides.length;
    var target = (next + total) % total;
    if (target === index) return;
    setSlide(target, user);
    if (user) stop();
  }

  function stop() {
    stopped = true;
    window.clearInterval(timer);
  }

  function play() {
    if (!autoplay || stopped || reduce) return;
    window.clearInterval(timer);
    timer = window.setInterval(function () {
      go(index + 1, false);
    }, delay);
  }

  root.classList.add('is-ready');
  slides.forEach(function (slide) {
    slide.removeAttribute('hidden');
  });
  setSlide(0, false);
  markEntered();

  root.addEventListener('click', function (event) {
    var tick = event.target.closest('[data-astra-hero-tick]');
    if (tick) {
      go(Number(tick.getAttribute('data-index')), true);
      return;
    }
    if (event.target.closest('[data-astra-hero-prev]')) go(index - 1, true);
    if (event.target.closest('[data-astra-hero-next]')) go(index + 1, true);
  });

  root.addEventListener('keydown', function (event) {
    if (event.target.closest('a, input, textarea, select')) return;
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      go(index - 1, true);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      go(index + 1, true);
    }
  });

  root.addEventListener('pointerdown', function (event) {
    if (event.target.closest('a, button')) return;
    tracking = true;
    startX = event.clientX;
    startY = event.clientY;
  });
  root.addEventListener('pointerup', function (event) {
    if (!tracking) return;
    tracking = false;
    var dx = event.clientX - startX;
    var dy = event.clientY - startY;
    if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
    go(dx < 0 ? index + 1 : index - 1, true);
  });
  root.addEventListener('pointercancel', function () { tracking = false; });

  var wheelLock = 0;
  root.addEventListener('wheel', function (event) {
    if (Math.abs(event.deltaX) < 24 || Math.abs(event.deltaX) < Math.abs(event.deltaY)) return;
    var now = Date.now();
    if (now - wheelLock < 500) return;
    wheelLock = now;
    go(event.deltaX > 0 ? index + 1 : index - 1, true);
  }, { passive: true });

  root.addEventListener('mouseenter', function () { window.clearInterval(timer); });
  root.addEventListener('mouseleave', function () { play(); });
  root.addEventListener('focusin', function () { window.clearInterval(timer); });
  root.addEventListener('focusout', function () { play(); });

  play();
})();
